import { Middleware, UnknownAction } from '@reduxjs/toolkit'

export const throwMiddleware: Middleware = () => next => (action: UnknownAction) => {
  next(action)
  if (action?.error) {
    throw action.error
  }
}
